import { IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React, { PropsWithChildren } from "react";
import { AuthenticationComponentWrapper } from "utilities/services/auth/authentication-component-wrapper";

export interface MultiTenantAuthenticationProps {
    instance: IPublicClientApplication;
}

export const MultiTenantAuthenticationWrapperComponent: AuthenticationComponentWrapper<
    MultiTenantAuthenticationProps
> = ({
    instance,
    children,
}: PropsWithChildren<MultiTenantAuthenticationProps>): React.ReactElement => {
    return (
        <div>
            <MsalProvider instance={instance}>{children}</MsalProvider>
        </div>
    );
};
